export default __webpack_public_path__ + "media/images/react_icons/pix-5e223749480b4685616d103fb93b98f7.svg";